"use strict";

var SubmitConfig = function () {
  var getBasePrograms = function () {
    const allPrograms = [
      {
        dataProgram: "trashProgram",
        programType: "impact",
        dataName: "trash group",
        displayName: "Trash Reduction",
        disabled: false,
        dataView: "trashView",
      },
      {
        dataProgram: "runoffProgram",
        programType: "impact",
        dataName: "stormwater group",
        displayName: "Runoff Reduction",
        disabled: false,
        dataView: "runoffView",
      },
      {
        dataProgram: "particulateProgram",
        programType: "impact",
        dataName: "stormwater group",
        displayName: "Particulate Reduction",
        disabled: false,
        dataView: "particulatesView",
      },
      {
        dataProgram: "runoffRatioProgram",
        programType: "impact",
        dataName: "stormwater group",
        displayName: "Runoff Ratio Reduction",
        disabled: false,
        dataView: "runoffRatioView",
      },
      {
        dataProgram: "watershedProgram",
        programType: "compliance",
        dataName: "stormwater group",
        dataView: "watershedView",
        displayName: "Watershed Characterization",
        disabled: false,
        linkSummaryEnabled: false,
        defaultStatus: "Multiple layers available",
        defaultHidden: true,
      },
      {
        dataProgram: "monitoringProgram",
        programType: "compliance",
        dataName: "water quality",
        dataView: null,
        displayName: "Water Quality Monitoring",
        disabled: false,
        linkSummaryEnabled: true,
        linkSummaryOnly: true,
        tool: "outmon",
      },
      {
        dataProgram: "assetProgram",
        programType: "compliance",
        dataName: "asset management",
        dataView: "assetManagementView",
        displayName: "Asset Lifecycle Optimization",
        disabled: false,
        linkSummaryEnabled: true,
        linkSummaryOnly: handleDataViewLinkDisable("assetManagementView"),
        displayTextOnly: Progeny.activeGroupIsRegulator(),
        tool: "assets",
      },
      {
        dataProgram: "bmpProgram",
        programType: "compliance",
        dataName: "stormwater group",
        dataView: "sbmpView",
        displayName: "Structural BMP Performance",
        disabled: false,
        tool: "bmpram",
      },
      {
        dataProgram: "fcsProgram",
        programType: "compliance",
        dataName: "trash group",
        dataView: "fcsView",
        displayName: "Public and Private Trash Full Capture Systems",
        disabled: false,
        tool: "trashram",
      },
      {
        dataProgram: "facilityProgram",
        programType: "compliance",
        dataName: "muni facility",
        dataView: "muniFacilityView",
        displayName: "Municipal Maintenance - Facilities",
        disabled: false,
        linkSummaryEnabled: false,
        tool: "muni",
      },
      {
        dataProgram: "outfallProgram",
        programType: "compliance",
        dataName: "muni outfall",
        dataView: "outfallView",
        displayName: "Municipal Maintenance - Outfalls",
        disabled: false,
        linkSummaryEnabled: false,
        tool: "muni",
      },
      {
        dataProgram: "muniBmpProgram",
        programType: "compliance",
        dataName: "muni bmp",
        dataView: "muniBmpView",
        displayName: "Municipal Maintenance - Structural BMPs",
        disabled: false,
        linkSummaryEnabled: false,
        tool: "muni",
      },
      {
        dataProgram: "muniCatchBasinProgram",
        programType: "compliance",
        dataName: "muni catch basin",
        dataView: "muniCatchBasinView",
        displayName: "Municipal Maintenance - Catch Basins",
        disabled: false,
        tool: "muni",
      },
      {
        dataProgram: "streetSweepingProgram",
        programType: "compliance",
        dataName: "stormwater group",
        dataView: "streetSweepingView",
        displayName: "Municipal Maintenance - Street Sweeping",
        disabled: handleStreetSweepingDisable(),
        linkSummaryEnabled: false,
        linkSummaryOnly: false,
        displayTextOnly: Progeny.activeGroupIsRegulator(),
        tool: "muni",
      },
      {
        dataProgram: "iddeProgram",
        programType: "compliance",
        dataName: "idde",
        dataView: "iddeView",
        displayName: "Illicit Discharge Detection and Elimination",
        disabled: false,
        linkSummaryEnabled: false,
        tool: "idde",
      },
      {
        dataProgram: "indcomProgram",
        programType: "compliance",
        dataName: "indcom",
        dataView: "indCommView",
        displayName: "Commercial and Industrial Facilities",
        disabled: false,
        linkSummaryEnabled: false,
        displayTextOnly: Progeny.activeGroupIsRegulator(),
        tool: "indcom",
      },
      {
        dataProgram: "constructionProgram",
        programType: "compliance",
        dataName: "construction",
        dataView: "constructionView",
        displayName: "Construction Site Management",
        disabled: false,
        tool: "construction",
      },
      {
        dataProgram: "lidProgram",
        programType: "compliance",
        dataName: "lid",
        dataView: "lidView",
        displayName: "Post-Construction Stormwater Management",
        disabled: false,
        tool: "lid",
      },
      {
        dataProgram: "publicProgram",
        programType: "compliance",
        dataName: "public",
        dataView: "publicView",
        displayName: "Public Education and Outreach",
        disabled: false,
        linkSummaryEnabled: false,
        displayTextOnly: Progeny.activeGroupIsRegulator(),
        tool: "peo",
      },
    ];

    if (!Progeny.isRegulator()) {
      const groupTools = ToolFunctions.getToolsEnabledForGroup();

      for (const program of allPrograms) {
        if (program.tool && !groupTools.includes(program.tool)) {
          program.hidden = true;
        }
      }
    }

    return allPrograms;
  };

  var findByDataView = function (dataView) {
    return getBasePrograms().find((config) => config.dataView === dataView);
  };

  var findByDataProgram = function (dataProgram) {
    return getBasePrograms().find((config) => config.dataProgram === dataProgram);
  };

  var findByDataName = function (dataName) {
    return getBasePrograms().filter((config) => config.dataName === dataName);
  };

  var getAll = function ({ filterByGroup = true } = {}) {
    const programs = getBasePrograms();
    const yearDropdownSelection = Tree.get("yearDropdownSelection");
    const groupId = Tree.get("activeGroup", "groupId");
    const permitSettingsByGroupId = PermitSettings.getPermitSettingsByGroupId(groupId);

    return programs.filter((program) => {
      if (yearDropdownSelection >= 2020) {
        program.displayName = PermitSettings.getDisplayPermitSectionByDataProgram(
          program.dataProgram,
          { includePermit: true },
        );

        if (!program.displayName) {
          throw new Error(`No permit section name found for ${JSON.stringify(program)}`);
        }

        const settings = permitSettingsByGroupId?.[program.dataProgram];
        if (settings?.show) {
          program.defaultHidden = false;
        }
        if (settings?.hide) {
          return false;
        }
      }

      return !program.defaultHidden && (filterByGroup ? !program.hidden : true);
    });
  };

  var getProgramImpact = function () {
    return getAll().filter((program) => program.programType === "impact");
  };

  var handleDataViewLinkDisable = function (dataView) {
    const selectedYear = Tree.get("yearDropdownSelection");
    if (dataView === "assetManagementView") {
      return selectedYear === 2021 ? false : true;
    }
  };

  var handleStreetSweepingDisable = function () {
    const selectedYear = Tree.get("yearDropdownSelection");
    return selectedYear >= 2023 ? false : true;
  };

  var getProgramCompliance = function () {
    return getAll().filter((program) => program.programType === "compliance");
  };

  return {
    findByDataView,
    findByDataProgram,
    findByDataName,
    getProgramImpact,
    getProgramCompliance,
    getAll,
    handleStreetSweepingDisable,
  };
};

module.exports = SubmitConfig();

const PermitSettings = require("../settings/permitSettings");
const Progeny = require("../../login/progeny");
const ToolFunctions = require("../../toolFunctions");
const Tree = require("../../tree");
